import { Theme, css } from '@emotion/react';

export const contentHeader = css`
  display: flex;
  justify-content: space-between;
`;

export const answerContainer = ({ colors, spacing }: Theme) => css`
  background-color: ${colors.bgLight};
  padding: ${spacing(3)}px ${spacing(2)}px;
  margin: ${spacing(2)}px 0;

  & > * + * {
    margin-top: ${spacing(2)}px;
  }
`;
